import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import {
  InputUserVerificationSearch,
  UserVerificationStatus,
} from "@scrile/api-provider/dist/api/UserVerificationProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import { MUTATION_TYPES } from "@/store/const";
import providers from "@/lib/api";

@Component
export default class WithUserVerification extends mixins(WithAuthUser) {
  public userVerificationSearch(data: InputUserVerificationSearch) {
    return providers.UserVerificationProvider.search({ data });
  }
  public userVerificationStart(userId: string) {
    return providers.UserVerificationProvider.start(userId);
  }

  public async userVerificationApproved(userId: string): Promise<boolean> {
    try {
      const { result } = await this.userVerificationSearch({ userIds: [userId] });
      let data = result.find(i => i.userId === userId);
      return data?.status !== UserVerificationStatus.UNVERIFIED ?? false;
    } catch (e) {
      return false;
    }
  }

  public userVerificationSetStatus(status: UserVerificationStatus) {
    this.$store.commit(MUTATION_TYPES.SET_USER_VERIFICATION_STATUS, status);
  }

  public async userVerificationFindMyStatus() {
    const dataVerification = await this.userVerificationSearch({ userIds: [this.authUserStrict.id] });
    const userVerificationStatus =
      dataVerification.result.find(i => i.userId === this.authUserStrict.id)?.status ||
      UserVerificationStatus.UNVERIFIED;
    this.userVerificationSetStatus(userVerificationStatus);
  }
}
